var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/*
 * Copyright 2017-2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
import camelcaseKeys from 'camelcase-keys';
import { ConsoleLogger as Logger, Credentials, getAmplifyUserAgent, } from '@aws-amplify/core';
import { LocationClient, SearchPlaceIndexForTextCommand, SearchPlaceIndexForPositionCommand, BatchPutGeofenceCommand, GetGeofenceCommand, ListGeofencesCommand, BatchDeleteGeofenceCommand, } from '@aws-sdk/client-location';
import { validateGeofenceId, validateGeofencesInput } from '../util';
var logger = new Logger('AmazonLocationServiceProvider');
var AmazonLocationServiceProvider = /** @class */ (function () {
    /**
     * Initialize Geo with AWS configurations
     * @param {Object} config - Configuration object for Geo
     */
    function AmazonLocationServiceProvider(config) {
        this._config = config ? config : {};
        logger.debug('Geo Options', this._config);
    }
    /**
     * get the category of the plugin
     * @returns {string} name of the category
     */
    AmazonLocationServiceProvider.prototype.getCategory = function () {
        return AmazonLocationServiceProvider.CATEGORY;
    };
    /**
     * get provider name of the plugin
     * @returns {string} name of the provider
     */
    AmazonLocationServiceProvider.prototype.getProviderName = function () {
        return AmazonLocationServiceProvider.PROVIDER_NAME;
    };
    /**
     * Configure Geo part with aws configuration
     * @param {Object} config - Configuration of the Geo
     * @return {Object} - Current configuration
     */
    AmazonLocationServiceProvider.prototype.configure = function (config) {
        logger.debug('configure Amazon Location Service Provider', config);
        if (!config)
            return this._config;
        this._config = Object.assign({}, this._config, config);
        return this._config;
    };
    /**
     * Get the map resources that are currently available through the provider
     * @returns {AmazonLocationServiceMapStyle[]}- Array of available map resources
     */
    AmazonLocationServiceProvider.prototype.getAvailableMaps = function () {
        this._verifyMapResources();
        var mapStyles = [];
        var availableMaps = this._config.maps.items;
        var region = this._config.region;
        for (var mapName in availableMaps) {
            var style = availableMaps[mapName].style;
            mapStyles.push({ mapName: mapName, style: style, region: region });
        }
        return mapStyles;
    };
    /**
     * Get the map resource set as default in amplify config
     * @returns {AmazonLocationServiceMapStyle} - Map resource set as the default in amplify config
     */
    AmazonLocationServiceProvider.prototype.getDefaultMap = function () {
        this._verifyMapResources();
        var mapName = this._config.maps.default;
        var style = this._config.maps.items[mapName].style;
        var region = this._config.region;
        return { mapName: mapName, style: style, region: region };
    };
    /**
     * Search by text input with optional parameters
     * @param  {string} text - The text string that is to be searched for
     * @param  {SearchByTextOptions} options? - Optional parameters to the search
     * @returns {Promise<Place[]>} - Promise resolves to a list of Places that match search parameters
     */
    AmazonLocationServiceProvider.prototype.searchByText = function (text, options) {
        return __awaiter(this, void 0, void 0, function () {
            var credentialsOK, locationServiceInput, client, command, response, error_1, PascalResults, results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._ensureCredentials()];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            throw new Error('No credentials');
                        }
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        locationServiceInput = {
                            Text: text,
                            IndexName: this._config.search_indices.default,
                        };
                        /**
                         * Map search options to Amazon Location Service input object
                         */
                        if (options) {
                            locationServiceInput.FilterCountries = options.countries;
                            locationServiceInput.MaxResults = options.maxResults;
                            if (options.searchIndexName) {
                                locationServiceInput.IndexName = options.searchIndexName;
                            }
                            if (options['biasPosition'] && options['searchAreaConstraints']) {
                                throw new Error('BiasPosition and SearchAreaConstraints are mutually exclusive, please remove one or the other from the options object');
                            }
                            if (options['biasPosition']) {
                                locationServiceInput.BiasPosition = options['biasPosition'];
                            }
                            if (options['searchAreaConstraints']) {
                                locationServiceInput.FilterBBox = options['searchAreaConstraints'];
                            }
                        }
                        client = new LocationClient({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: getAmplifyUserAgent(),
                        });
                        command = new SearchPlaceIndexForTextCommand(locationServiceInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, client.send(command)];
                    case 3:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        logger.debug(error_1);
                        throw error_1;
                    case 5:
                        PascalResults = response.Results.map(function (result) { return result.Place; });
                        results = camelcaseKeys(PascalResults, {
                            deep: true,
                        });
                        return [2 /*return*/, results];
                }
            });
        });
    };
    /**
     * Reverse geocoding search via a coordinate point on the map
     * @param coordinates - Coordinates array for the search input
     * @param options - Options parameters for the search
     * @returns {Promise<Place>} - Promise that resolves to a place matching search coordinates
     */
    AmazonLocationServiceProvider.prototype.searchByCoordinates = function (coordinates, options) {
        return __awaiter(this, void 0, void 0, function () {
            var credentialsOK, locationServiceInput, client, command, response, error_2, PascalResults, results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._ensureCredentials()];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            throw new Error('No credentials');
                        }
                        this._verifySearchIndex(options === null || options === void 0 ? void 0 : options.searchIndexName);
                        locationServiceInput = {
                            Position: coordinates,
                            IndexName: this._config.search_indices.default,
                        };
                        if (options) {
                            if (options.searchIndexName) {
                                locationServiceInput.IndexName = options.searchIndexName;
                            }
                            locationServiceInput.MaxResults = options.maxResults;
                        }
                        client = new LocationClient({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: getAmplifyUserAgent(),
                        });
                        command = new SearchPlaceIndexForPositionCommand(locationServiceInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, client.send(command)];
                    case 3:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        logger.debug(error_2);
                        throw error_2;
                    case 5:
                        PascalResults = response.Results.map(function (result) { return result.Place; });
                        results = camelcaseKeys(PascalResults[0], {
                            deep: true,
                        });
                        return [2 /*return*/, results];
                }
            });
        });
    };
    /**
     * Create geofences inside of a geofence collection
     * @param geofences - Array of geofence objects to create
     * @param options? - Optional parameters for creating geofences
     * @returns {Promise<AmazonLocationServiceSaveGeofencesResults>} - Promise that resolves to an object with:
     *   successes: list of geofences successfully created
     *   errors: list of geofences that failed to create
     */
    AmazonLocationServiceProvider.prototype.saveGeofences = function (geofences, options) {
        return __awaiter(this, void 0, void 0, function () {
            var credentialsOK, PascalGeofences, results, geofenceBatches, apiLimit;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (geofences.length < 1) {
                            throw new Error('Geofence input array is empty');
                        }
                        return [4 /*yield*/, this._ensureCredentials()];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            throw new Error('No credentials');
                        }
                        // Verify geofence collection exists in aws-config.js
                        try {
                            this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        }
                        catch (error) {
                            logger.debug(error);
                            throw error;
                        }
                        validateGeofencesInput(geofences);
                        PascalGeofences = geofences.map(function (_a) {
                            var geofenceId = _a.geofenceId, polygon = _a.geometry.polygon;
                            return {
                                GeofenceId: geofenceId,
                                Geometry: {
                                    Polygon: polygon,
                                },
                            };
                        });
                        results = {
                            successes: [],
                            errors: [],
                        };
                        geofenceBatches = [];
                        while (PascalGeofences.length > 0) {
                            apiLimit = 10;
                            geofenceBatches.push(PascalGeofences.splice(0, apiLimit));
                        }
                        return [4 /*yield*/, Promise.all(geofenceBatches.map(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                                var response, error_3;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, this._AmazonLocationServiceBatchPutGeofenceCall(batch, (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default)];
                                        case 1:
                                            response = _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            error_3 = _a.sent();
                                            // If the API call fails, add the geofences to the errors array and move to next batch
                                            batch.forEach(function (geofence) {
                                                results.errors.push({
                                                    geofenceId: geofence.GeofenceId,
                                                    error: {
                                                        code: 'APIConnectionError',
                                                        message: error_3.message,
                                                    },
                                                });
                                            });
                                            return [2 /*return*/];
                                        case 3:
                                            // Push all successes to results
                                            response.Successes.forEach(function (success) {
                                                var GeofenceId = success.GeofenceId, CreateTime = success.CreateTime, UpdateTime = success.UpdateTime;
                                                results.successes.push({
                                                    geofenceId: GeofenceId,
                                                    createTime: CreateTime,
                                                    updateTime: UpdateTime,
                                                });
                                            });
                                            // Push all errors to results
                                            response.Errors.forEach(function (error) {
                                                var _a = error.Error, Code = _a.Code, Message = _a.Message, GeofenceId = error.GeofenceId;
                                                results.errors.push({
                                                    error: {
                                                        code: Code,
                                                        message: Message,
                                                    },
                                                    geofenceId: GeofenceId,
                                                });
                                            });
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, results];
                }
            });
        });
    };
    /**
     * Get geofence from a geofence collection
     * @param geofenceId:string
     * @param options?: Optional parameters for getGeofence
     * @returns {Promise<AmazonLocationServiceGeofence>} - Promise that resolves to a geofence object
     */
    AmazonLocationServiceProvider.prototype.getGeofence = function (geofenceId, options) {
        return __awaiter(this, void 0, void 0, function () {
            var credentialsOK, client, commandInput, command, response, error_4, GeofenceId, CreateTime, UpdateTime, Status, Geometry, geofence;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._ensureCredentials()];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            throw new Error('No credentials');
                        }
                        // Verify geofence collection exists in aws-config.js
                        try {
                            this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        }
                        catch (error) {
                            logger.debug(error);
                            throw error;
                        }
                        validateGeofenceId(geofenceId);
                        client = new LocationClient({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: getAmplifyUserAgent(),
                        });
                        commandInput = {
                            GeofenceId: geofenceId,
                            CollectionName: (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default,
                        };
                        command = new GetGeofenceCommand(commandInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, client.send(command)];
                    case 3:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_4 = _a.sent();
                        logger.debug(error_4);
                        throw error_4;
                    case 5:
                        GeofenceId = response.GeofenceId, CreateTime = response.CreateTime, UpdateTime = response.UpdateTime, Status = response.Status, Geometry = response.Geometry;
                        geofence = {
                            createTime: CreateTime,
                            geofenceId: GeofenceId,
                            geometry: {
                                polygon: Geometry.Polygon,
                            },
                            status: Status,
                            updateTime: UpdateTime,
                        };
                        return [2 /*return*/, geofence];
                }
            });
        });
    };
    /**
     * List geofences from a geofence collection
     * @param  options?: ListGeofenceOptions
     * @returns {Promise<ListGeofencesResults>} - Promise that resolves to an object with:
     *   entries: list of geofences - 100 geofences are listed per page
     *   nextToken: token for next page of geofences
     */
    AmazonLocationServiceProvider.prototype.listGeofences = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var credentialsOK, client, listGeofencesInput, command, response, error_5, NextToken, Entries, results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._ensureCredentials()];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            throw new Error('No credentials');
                        }
                        // Verify geofence collection exists in aws-config.js
                        try {
                            this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        }
                        catch (error) {
                            logger.debug(error);
                            throw error;
                        }
                        client = new LocationClient({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: getAmplifyUserAgent(),
                        });
                        listGeofencesInput = {
                            NextToken: options === null || options === void 0 ? void 0 : options.nextToken,
                            CollectionName: (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default,
                        };
                        command = new ListGeofencesCommand(listGeofencesInput);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, client.send(command)];
                    case 3:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_5 = _a.sent();
                        logger.debug(error_5);
                        throw error_5;
                    case 5:
                        NextToken = response.NextToken, Entries = response.Entries;
                        results = {
                            entries: Entries.map(function (_a) {
                                var GeofenceId = _a.GeofenceId, CreateTime = _a.CreateTime, UpdateTime = _a.UpdateTime, Status = _a.Status, Polygon = _a.Geometry.Polygon;
                                return {
                                    geofenceId: GeofenceId,
                                    createTime: CreateTime,
                                    updateTime: UpdateTime,
                                    status: Status,
                                    geometry: {
                                        polygon: Polygon,
                                    },
                                };
                            }),
                            nextToken: NextToken,
                        };
                        return [2 /*return*/, results];
                }
            });
        });
    };
    /**
     * Delete geofences from a geofence collection
     * @param geofenceIds: string|string[]
     * @param options?: GeofenceOptions
     * @returns {Promise<DeleteGeofencesResults>} - Promise that resolves to an object with:
     *  successes: list of geofences successfully deleted
     *  errors: list of geofences that failed to delete
     */
    AmazonLocationServiceProvider.prototype.deleteGeofences = function (geofenceIds, options) {
        return __awaiter(this, void 0, void 0, function () {
            var credentialsOK, badGeofenceIds, results, geofenceIdBatches, count;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (geofenceIds.length < 1) {
                            throw new Error('GeofenceId input array is empty');
                        }
                        return [4 /*yield*/, this._ensureCredentials()];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            throw new Error('No credentials');
                        }
                        this._verifyGeofenceCollections(options === null || options === void 0 ? void 0 : options.collectionName);
                        badGeofenceIds = geofenceIds.filter(function (geofenceId) {
                            try {
                                validateGeofenceId(geofenceId);
                            }
                            catch (error) {
                                return true;
                            }
                        });
                        if (badGeofenceIds.length > 0) {
                            throw new Error("Invalid geofence ids: " + badGeofenceIds.join(', '));
                        }
                        results = {
                            successes: [],
                            errors: [],
                        };
                        geofenceIdBatches = [];
                        count = 0;
                        while (count < geofenceIds.length) {
                            geofenceIdBatches.push(geofenceIds.slice(count, (count += 10)));
                        }
                        return [4 /*yield*/, Promise.all(geofenceIdBatches.map(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                                var response, error_6, badGeofenceIds;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _b.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, this._AmazonLocationServiceBatchDeleteGeofenceCall(batch, (options === null || options === void 0 ? void 0 : options.collectionName) || this._config.geofenceCollections.default)];
                                        case 1:
                                            response = _b.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            error_6 = _b.sent();
                                            // If the API call fails, add the geofences to the errors array and move to next batch
                                            batch.forEach(function (geofenceId) {
                                                var errorObject = {
                                                    geofenceId: geofenceId,
                                                    error: {
                                                        code: error_6.message,
                                                        message: error_6.message,
                                                    },
                                                };
                                                results.errors.push(errorObject);
                                            });
                                            return [2 /*return*/];
                                        case 3:
                                            badGeofenceIds = response.Errors.map(function (_a) {
                                                var geofenceId = _a.geofenceId;
                                                return geofenceId;
                                            });
                                            (_a = results.successes).push.apply(_a, __spread(batch.filter(function (Id) { return !badGeofenceIds.includes(Id); })));
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, results];
                }
            });
        });
    };
    /**
     * @private
     */
    AmazonLocationServiceProvider.prototype._ensureCredentials = function () {
        return __awaiter(this, void 0, void 0, function () {
            var credentials, cred, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Credentials.get()];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials)
                            return [2 /*return*/, false];
                        cred = Credentials.shear(credentials);
                        logger.debug('Set credentials for storage. Credentials are:', cred);
                        this._config.credentials = cred;
                        return [2 /*return*/, true];
                    case 2:
                        error_7 = _a.sent();
                        logger.debug('Ensure credentials error. Credentials are:', error_7);
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AmazonLocationServiceProvider.prototype._verifyMapResources = function () {
        if (!this._config.maps) {
            var errorString = "No map resources found in amplify config, run 'amplify add geo' to create one and run `amplify push` after";
            logger.debug(errorString);
            throw new Error(errorString);
        }
        if (!this._config.maps.default) {
            var errorString = "No default map resource found in amplify config, run 'amplify add geo' to create one and run `amplify push` after";
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype._verifySearchIndex = function (optionalSearchIndex) {
        if ((!this._config.search_indices || !this._config.search_indices.default) &&
            !optionalSearchIndex) {
            var errorString = 'No Search Index found in amplify config, please run `amplify add geo` to create one and run `amplify push` after.';
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype._verifyGeofenceCollections = function (optionalGeofenceCollectionName) {
        if ((!this._config.geofenceCollections ||
            !this._config.geofenceCollections.default) &&
            !optionalGeofenceCollectionName) {
            var errorString = 'No Geofence Collections found, please run `amplify add geo` to create one and run `amplify push` after.';
            logger.debug(errorString);
            throw new Error(errorString);
        }
    };
    AmazonLocationServiceProvider.prototype._AmazonLocationServiceBatchPutGeofenceCall = function (PascalGeofences, collectionName) {
        return __awaiter(this, void 0, void 0, function () {
            var geofenceInput, client, command, response, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        geofenceInput = {
                            Entries: PascalGeofences,
                            CollectionName: collectionName || this._config.geofenceCollections.default,
                        };
                        client = new LocationClient({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: getAmplifyUserAgent(),
                        });
                        command = new BatchPutGeofenceCommand(geofenceInput);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, client.send(command)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_8 = _a.sent();
                        throw error_8;
                    case 4: return [2 /*return*/, response];
                }
            });
        });
    };
    AmazonLocationServiceProvider.prototype._AmazonLocationServiceBatchDeleteGeofenceCall = function (geofenceIds, collectionName) {
        return __awaiter(this, void 0, void 0, function () {
            var deleteGeofencesInput, client, command, response, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deleteGeofencesInput = {
                            GeofenceIds: geofenceIds,
                            CollectionName: collectionName || this._config.geofenceCollections.default,
                        };
                        client = new LocationClient({
                            credentials: this._config.credentials,
                            region: this._config.region,
                            customUserAgent: getAmplifyUserAgent(),
                        });
                        command = new BatchDeleteGeofenceCommand(deleteGeofencesInput);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, client.send(command)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_9 = _a.sent();
                        throw error_9;
                    case 4: return [2 /*return*/, response];
                }
            });
        });
    };
    AmazonLocationServiceProvider.CATEGORY = 'Geo';
    AmazonLocationServiceProvider.PROVIDER_NAME = 'AmazonLocationService';
    return AmazonLocationServiceProvider;
}());
export { AmazonLocationServiceProvider };
//# sourceMappingURL=AmazonLocationServiceProvider.js.map